module.exports = __webpack_public_path__ + "static/apple-touch-icon-c8732ef88e19233918c5da82bc309d6a.png";